angular.module('charts')
  .directive("usageBarGraph", function() {
    return {
      restrict: "E",
      scope: {
        graph: '=',
        heading: '@',
        yLabelFilter: '@',
        numStudents: '=',
        lowThreshold: '@',
        highThreshold: '@',
        minRange: '@',
        noDataText: "@",
        tooltipPrefix: "@"
      },
      templateUrl: '/resources/charts/partials/usage-bar-graph.html',
      controller: ['$scope', '$element', '$timeout', 'highchartConfigs', '$state', function($scope, $element, $timeout, $highchartConfigs, $state) {

        var lowThreshold,
            highThreshold;

        var getTooltip = function(data) {
          if (data.points[0].y + data.points[1].y === 0) {
            return false;
          } else if ($scope.yLabelFilter === 'lessons') {
            // default tooltip prefix
            var labelPrefix = 'Total Lessons:';
            if ($scope.tooltipPrefix !== undefined) {
              labelPrefix = $scope.tooltipPrefix;
            }
            var label = data.points[1].y !== 1 ? 'lessons' : 'lesson';
            return '<span style="text-transform: capitalize; font-weight: bold;">' + data.x + '</span><br></br>' +
              labelPrefix + ' ' + data.points[1].y + ' ' + label;
          } else {
            return '<span style="text-transform: capitalize; font-weight: bold;">' + data.x + '</span><br></br>' +
              data.points[0].series.name + ': ' + data.points[0].y + ' ' + $scope.yLabelFilter + '<br></br>' +
              data.points[1].series.name + ': ' + data.points[1].y + ' ' + $scope.yLabelFilter + '<br></br>' +
              'Total Use: ' + (data.points[0].y + data.points[1].y) + ' ' + $scope.yLabelFilter;
          }
        };

        var updateThresholds = function(by) {
          var multiplier = 4;

          lowThreshold = $scope.lowThreshold; // passed in by adding a low-threshold="INT" property/value in the usage-bar-graph tag
          highThreshold = $scope.highThreshold; // passed in by adding a high-threshold="INT" property/value in the usage-bar-graph tag

          //Lessons Per Day = Always gray
          //Lessons Per Week = 0-2 is orange, 3-7 is gray, 8+ is green
          //Lessons Per Month = 0-8 is orange, 9-28 is gray, 29+ is green
          //
          //Minutes Per Day = Always gray
          //Minutes Per Week = 0-15 is orange, 16-59 is gray, 60+ is green
          //Minutes Per Month = 0-60 is orange, 61-239 is gray, 240+ is green

          switch (by) {
            case 'day':
              // Always gray
              $scope.byDaySelected = true;
              break;
            case 'week':
              // By Week. Do nothing. Default
              $scope.byDaySelected = false;
              break;
            case 'month':
              $scope.byDaySelected = false;
              lowThreshold = ($scope.lowThreshold * multiplier);
              highThreshold = ($scope.highThreshold * multiplier);
              break;
            default:
              console.error('Error: Invalid \'by\' parameter');
          }
        };

        $scope.byDaySelected = false;

        /* Watch for changes on scope object - since it is databound
         * it will react to any changes to the item.usageGraph object.
         * Note - make sure when you update the usageGraph object that
         * you use $scope.$apply() to update bindings. Or in this case
         * $timeout which clears the callstack and does a $scope.$apply();
         */
        $scope.$watchCollection('graph', function(graph) {
          $timeout(function() {
            if (graph) {
              $scope.drawGraph();
            } else {
              $scope.showGraph = false;
            }
          }, 0);

        });
        $scope.drawGraph = function() {
          updateThresholds($state.params.by);

          $scope.showGraph = false;
          $scope.chartData = {
            formattedData: [{
              name: 'Out of School Use',
              data: [],
              dataLabels: {
                enabled: false
              }
            }, {
              name: 'School Use',
              data: [],
              dataLabels: {
                enabled: false
              }
            }],
            data: $scope.graph.data,
            xAxisLabels: $scope.graph.xAxisLabels,
            lowThreshold: lowThreshold,
            highThreshold: highThreshold,
            colors: {
              low: {
                normal: '#FF5D26',
                light: '#FFAE92'
              },
              high: {
                normal: '#6ABD45',
                light: '#B4DEA2'
              },
              normal: {
                normal: '#CECBCD',
                light: '#DCDBDC'
              }

            }
          };

          var chartHasData = false;

          $scope.chartData.data.forEach(function(dataPoint) {
            if ((dataPoint[0] !== undefined && dataPoint[0] !== 0) ||
                (dataPoint[1] !== undefined && dataPoint[1] !== 0)) {
                chartHasData = true;
              }
          });

          if (chartHasData) {
            // Iterate through each data point - setting the color for each point
            $scope.chartData.data.forEach(function(dataPoint) {
              // If the y-value is undefined, make it 0
              if (dataPoint[1] === undefined) { dataPoint[1] = 0; }
              if ($scope.yLabelFilter === 'minutes') {
                dataPoint[0] = Math.round(dataPoint[0]);
                dataPoint[1] = Math.round(dataPoint[1]);
              }
              else if ($scope.yLabelFilter === 'lessons') {
                dataPoint[0] = Math.round(dataPoint[0]*10)/10;
                dataPoint[1] = Math.round(dataPoint[1]*10)/10;
              }
              // Set color
              var underThreshold = (dataPoint[0] + dataPoint[1] < $scope.chartData.lowThreshold);
              var overThreshold = (dataPoint[0] + dataPoint[1] > $scope.chartData.highThreshold);

              var colors = $scope.chartData.colors.normal;
              if (underThreshold && !$scope.byDaySelected) {
                colors = $scope.chartData.colors.low;
              }
              if (overThreshold && !$scope.byDaySelected) {
                colors = $scope.chartData.colors.high;
              }

              $scope.chartData.formattedData[1].data.push({
                y: dataPoint[0],
                color: colors.normal
              });
              $scope.chartData.formattedData[0].data.push({
                y: dataPoint[1],
                color: colors.light
              });
            });
          }

          $scope.chartConfig = {
            chart: {
              type: "column",
              backgroundColor: 'transparent'
            },
            title: $highchartConfigs.title,
            plotOptions: $highchartConfigs.plotOptions,
            legend: {
              enabled: false
            },
            tooltip: {
              formatter: function () {
                return getTooltip(this);
              },
              style: {
                textAlign: 'right'
              },
              shared: true
            },
            credits: {
              enabled: false
            },
            loading: false,
            xAxis: {
              categories: $scope.chartData.xAxisLabels,
              tickColor: 'transparent',
              labels: {
                style: $highchartConfigs.labelStyle
              },
              lineColor: '#e2e0dc'
            },
            yAxis: {
              min: 0,
              minRange: Number(highThreshold),
              title: {
                text: ''
              },
              gridLineColor: '#e2e0dc',
              tickAmount: 3,
              labels: {
                formatter: function () {
                  return $highchartConfigs.getYAxisLabelFormatterPrint(this, $scope.yLabelFilter);
                },
                style: $highchartConfigs.labelStyle
              },
              stackLabels: $highchartConfigs.getYAxisStackLabels()
            },
            series: $scope.chartData.formattedData
          };

          // In order to have y labels visible when there is no data
          if (!chartHasData) {
            if ($scope.yLabelFilter === 'minutes') {
              // todo do we need to specify other default value ?
              $scope.chartConfig.yAxis.max = 70;
            }
            else if ($scope.yLabelFilter === 'lessons') {
              $scope.chartConfig.yAxis.max = 10;
            }
            if ($scope.noDataText !== undefined) {
              $scope.chartConfig.lang = {noData: $scope.noDataText};
            }
          }

          $scope.showGraph = true;
        };

      }]
    };
  });
